import React from 'react'
import { Col, Row } from 'react-flexbox-grid'
import { withRouter } from 'react-router-dom'
import * as Constants from '../../../constants'
import { Button, Checkbox, Form, Input, InputNumber } from 'antd'
import './styles.css'

const FormVehicleInventory = (props) => {
    const { loading, onSubmitVehicleInventory, onBack, isEditing, vehicleInventoryToEdit } = props
    const [form] = Form.useForm()

    const handleSubmit = values => {
        if (isEditing && vehicleInventoryToEdit) {
            const obj = {
                id: vehicleInventoryToEdit.id,
                name: values.name,
                enabled: values.enabled,
                fuelQuantity: values.fuelQuantity,
                kilometres: values.kilometres,
                plate: values.plate,
                generalInformation: values.generalInformation ?? null,
                type: Constants.INVENTORY_TYPES.VEHICLE
            }
            onSubmitVehicleInventory(obj)
        } else {
            const obj = {
                name: values.name,
                plate: values.plate ?? null,
                enabled: values.enabled,
                fuelQuantity: values.fuelQuantity ?? null,
                kilometres: values.kilometres ?? null,
                generalInformation: values.generalInformation ?? null,
                type: Constants.INVENTORY_TYPES.VEHICLE
            }
            onSubmitVehicleInventory(obj)
        }
    }

    const handleReset = () => {
        form.resetFields()
    }

    const getInitialValuesFromVehicleInventory = () => {
        return {
            name: vehicleInventoryToEdit.name,
            plate: vehicleInventoryToEdit.plate ?? null,
            enabled: vehicleInventoryToEdit.enabled,
            fuelQuantity: vehicleInventoryToEdit.fuelQuantity ?? null,
            kilometres: vehicleInventoryToEdit.kilometres ?? null,
            generalInformation: vehicleInventoryToEdit.generalInformation ?? null
        }
    }

    return (
        <Form onFinish={handleSubmit} form={form}
              initialValues={isEditing && getInitialValuesFromVehicleInventory()}>
            <Row>
                <Col xs={12} md={6}>
                    <Form.Item name="name" rules={[{
                        required: true,
                        message: 'Por favor, ingresa el nombre del vehículo'
                    }]}>
                        <Input placeholder="Nombre"/>
                    </Form.Item>
                </Col>
                <Col xs={12} md={6}>
                    <Form.Item name="plate" rules={[{
                        required: true,
                        message: 'Por favor, ingresa la patente del vehículo'
                    }]}>
                        <Input placeholder="Patente"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={6}>
                    <Form.Item name="fuelQuantity">
                        <Input placeholder="Combustible"/>
                    </Form.Item>
                </Col>
                <Col xs={12} md={6}>
                    <Form.Item name="kilometres">
                        <InputNumber className="inputFormVehicleInventory" placeholder="Kilómetros" min={0}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={6}>
                    <Form.Item name="generalInformation">
                        <Input placeholder="Información"/>
                    </Form.Item>
                </Col>
                <Col xs={12} md={6}>
                    <Form.Item name="enabled" valuePropName="checked" initialValue={true}>
                        <Checkbox>Habilitado</Checkbox>
                    </Form.Item>
                </Col>
            </Row>
            <Row center="xs">
                <Col xs={12} sm={6} md={3}>
                    <Button className="buttonFormVehicleInventory" type="primary" htmlType="submit" loading={loading}>
                        Cargar
                    </Button>
                </Col>
                <Col xs={12} sm={6} md={3}>
                    <Button className="buttonFormVehicleInventory" onClick={handleReset} loading={loading}>
                        {isEditing ? 'Restablecer' : 'Limpiar'}
                    </Button>
                </Col>
            </Row>
            <Row center="xs">
                <Col xs={12} sm={6} md={3}>
                    <Button className="buttonFormVehicleInventory" onClick={onBack}
                            loading={loading}>
                        Salir
                    </Button>
                </Col>
            </Row>
        </Form>
    )
}

export default withRouter(FormVehicleInventory)
